import React from 'react';
import { RestartApplicationButton } from 'rental/components/RestartApplicationButton';
import { bsClasses } from 'shared/bootstrap';
import { usePortalContext } from '../app/AppContext';
import { TestDataState, useSetImportantInfoReadMutation, useSetResidentStatusMutation, useSetTestDataStateMutation } from '../generated.graphql';
import { CancelApplicationButton } from './CancelApplication';


interface Props {
}


export const DevFooter = (props: Props) => {
  const app = usePortalContext();
  const portalSlug = app.portal.slug;
  const [importantInfoResult, setImportantInfoRead] = useSetImportantInfoReadMutation();
  const [setResidentStatusResult, setResidentStatus] = useSetResidentStatusMutation();
  const [testResult, setTestData] = useSetTestDataStateMutation();
  return (
    <footer className="bg-dark text-white py-1 small text-center">
      <div className={bsClasses.container}>

        <CancelApplicationButton className="btn btn-link btn-sm" portalSlug={app.portalSlug} />

        <RestartApplicationButton className="btn btn-link btn-sm" portalSlug={portalSlug}/>

        <button 
          className="btn btn-link btn-sm" 
          type="button"
          onClick={async () => {
            await Promise.all([
              setImportantInfoRead({input: {portalSlug}}),
              setResidentStatus({input: {portalSlug, residentStatus: 'C'}}),
            ])
          }} 
          disabled={importantInfoResult.fetching || setResidentStatusResult.fetching}
        >
          Set important info read
        </button>
        
        {Object.values(TestDataState).map(action => (
          <button key={action} className="btn btn-link btn-sm"  type="button"
            onClick={() => setTestData({input:{portalSlug, action:(action as TestDataState)}})} 
            disabled={testResult.fetching}>
              {action}
          </button>
        ))}
      </div>
    </footer>
  )
}